import AuditTrail from "../audit.trail";

export const DropDownLog = (WrappedComponent) => (props) => {
  const { onChange, onClick, event, eventParams, ...otherProps } = props;

  const onLog = (event, action, eventParams) => {
      if (event && action) {
          let data = Object.assign({tag: 'dropdown', event: action, label: props.label? props.label : ''}, eventParams);
          const items = props && props.items? props.items.map(((i) => i.value)) : null;
          if (items) {
              data.items = items;
          }
          if (props.value) {
              data.value = props.value;
          }
          AuditTrail.sendLog(event,data);
      }
  }

  return (
    <WrappedComponent
        {...otherProps}
        onChange={(context) => {
            onLog(event, 'onChange', eventParams);
            if (props.onChange) {
                props.onChange(context);
            }
        }}
        onClick={(context) => {
            let _eventParams = Object.assign({}, eventParams);
            _eventParams.open = context;
            onLog(event, 'onClick', _eventParams);
            if (props.onClick) {
                props.onClick(context);
            }
        }}
        onSelect={(context) => {
            onLog(event, 'onSelect', eventParams);
            if (props.onSelect) {
                props.onSelect(context);
            }
        }}
    />
  );
};
